<div class="beta-toggle-floating"
     [cdkDragDisabled]="!dragEnabled"
     cdkDrag
     cdkDragBoundary="body"
     cdkDragRootElement=".cs-toggle-user-preference-container">
    <div class="cs-d-flex align-items-center">
     <span class="drag-handle" cdkDragHandle title="Drag" *ngIf="dragEnabled">
         <i class="fas fa-grip-vertical drag-handle"></i>
     </span>
        <label class="toggle-label" >
            <span class="toggle-text">Ready to explore the beta view?</span>
            <input type="checkbox" [(ngModel)]="toggleSwitch" (change)="setUserPropertyViewPreference()" />
            <span class="toggle-slider"></span>
        </label>
    </div>
    <div class="feedback-form" *ngIf="showFeedbackForm">
        <p class="beta-message">
            We're sorry to see you switch back. We'd love to know why so we can continue to improve the software
        </p>
        <div class="beta-reason-select">
            <select csSelect2 (onChange)="validateFeedback($event)" class="w-100" [select2Config]="select2Config">
                <option value="" translate>--Select reason--</option>
                <option *ngFor="let reason of reasons" [value]="reason.id">{{reason.description}}</option>
            </select>
        </div>
        <textarea class="tall" id="comments" [(ngModel)]="comments" placeholder="What your feedback"></textarea>

        <div class="feedback-actions" cdkDragHandle>
            <button class="beta-button" [ngClass]="{'beta-disabled-btn': !canSubmit }" [disabled]="!canSubmit" (click)="submitFeedbackForm()">Turn off the beta</button>
        </div>
    </div>
</div>
